import axios from "axios";

export default function getAgents() {
  return new Promise((resolve, reject) =>
    axios
      .get("/support/api/v1/admin/agents")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
